export const loadStartHandler = event => {
  const $video = event.currentTarget;
  const $videoContainer = $video.closest('.js-video');

  if ($videoContainer.classList.contains('is-ready')) return;

  $videoContainer.classList.add('is-ready');
  $video.controls = false;
};
